function getRotationAngle(rotation) {
  if (rotation == 0) { return ''; }
  if (rotation == 90) { return '-rotate-90'; }
  if (rotation == 180) { return '-rotate-180'; }
  if (rotation == 270) { return '-rotate-270'; }
}

export { getRotationAngle };
